<template>
  <v-list-item :class="{'list-item': true, 'title-time-list-item': border}" two-line>
    <v-list-item-content>
      <fin-time-and-tags :datetime="item.date"
                         :datetimePrepend="datePrefix"
                         :tag="null"
                         class="mb-1"/>
      <v-list-item-subtitle><h5>{{ item.name }}</h5></v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "FinTitleAndTimeListItem",
  props: {
    item: Object,
    datePrefix: String,
    border: {type: Boolean, default: true}
  }
}
</script>

<style lang="scss" scoped>

.title-time-list-item {
  border-bottom: solid 1px $fin-color-light-sky-blue;
}

.list-item {
  padding: 0;
}

.top-line {
  font-family: $body-font-family;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 1px;
  color: $fin-color-cool-grey;
}

h5 {
  font-family: $body-font-family;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  /* additional */
  white-space: initial;

  @media only screen and (max-width: 600px) {
    font-size: 14px;
  }
}

.category {
  font-family: $body-font-family;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: $fin-color-primary-dark;

  padding: 4px 8px;
  border: solid 1px $fin-color-light-blue-gray;
  background-color: $fin-color-pale-grey;

  display: inline-block;
}


</style>
